/*
 * @Author: 肖玲
 * @Date: 2023-02-17 15:04:35
 * @LastEditTime: 2023-02-17 18:35:14
 * @LastEditors: 肖玲
 * @Description: 
 * @FilePath: \p2ps_vip_web\src\router\learning-platform\learning-assessment-manage\modules\statisticalAnalysisRouter.js
 * 统计分析
 */
const statisticalAnalysisRouter = [
  // 学习平台 资料库使用统计
  {
    path: '/studyPlatform/database-usage-statistics',
    name: 'studyPlatformDatabaseUsageStatistics',
    component: () =>
      // import(
      //   /*webpackChunkName:"studyPlatformSystemSettings" */
      //   '@/views/studyPlatform/DatabaseUsageStatistics.vue'
      // ),
    import(
      /*webpackChunkName:"studyPlatformSystemSettings" */
      '@/views/learning-platform/learning-assessment-manage/statistica-analysis/database-usage-statistics/Page.vue'
    ),
    meta: {
      SecondaryMenu: '统计分析', //二级菜单
      title: '资料库使用统计',
    },
  },
  // 学习平台 资料库使用统计 详情
  {
    path: '/studyPlatform/database-usage-statistics-detail/:study_material_id/:title/:classify_title',
    name: 'studyPlatformDatabaseUsageStatisticsDetail',
    component: () =>
      // import(
      //   /*webpackChunkName:"studyPlatformSystemSettings" */
      //   '@/views/studyPlatform/DatabaseUsageStatisticsDetail.vue'
      // ),
      import(
        /*webpackChunkName:"studyPlatformSystemSettings" */
        '@/views/learning-platform/learning-assessment-manage/statistica-analysis/database-usage-statistics/Detail.vue'
      ),
    meta: {
      SecondaryMenu: '统计分析', //二级菜单
      title: '资料库使用统计详情',
      breadcrumb: [{
        title: '资料库使用统计',
        name: 'studyPlatformDatabaseUsageStatistics',
      }, ],
    },
  },
]
export default statisticalAnalysisRouter